import { Paginated } from "../../../../common/domain/models/paginated_models";
import { EquipamentoMedicaoList } from "../../domain/models/EquipamentoMedicao_List";
import { IEquipamentoMedicaoService } from "../services/equipamentoMedicaoService";
import { IEquipamentoMedicaoRepository } from "../../domain/repositories/EquipamentoMedicao_Repositorie";
import { EquipamentoMedicao } from "../../domain/models/EquipamentoMedicao";
import { EquipamentoMedIndicadores } from "../../domain/models/EquipamentoMed_indicadores";
import { EquipamentoMedicaoHistorico } from "../../../../common/domain/models/equipamento_medicao_historico";
import { CadastroCores } from "../../domain/models/cadastro_cores";

export class EquipamentoMedicaoRepository implements IEquipamentoMedicaoRepository {
    constructor(private readonly service: IEquipamentoMedicaoService) { }

    async getAllEquipamentoMedicaoList(
        idObra?: number | null,
        idsCentroCusto?: number[],
        status?: string | null,
        equipamento?: string | null,
        responsavelPeloEquipamento?: string | null,
        dataCalibracaoDe?: Date | null,
        dataCalibracaoAte?: Date | null,
        page?: number | null,
        rowsPerPage?: number | null
    ): Promise<Paginated<EquipamentoMedicaoList>> {
        return this.service.getAllEquipamentoMedicaoLista({
            idObra,
            idsCentroCusto,
            status,
            equipamento,
            responsavelPeloEquipamento,
            dataCalibracaoDe,
            dataCalibracaoAte,
            page,
            rowsPerPage
        });

    }

    async getEquipamentoMedicaoById(
        idEquipamentoMedicao: number
    ): Promise<EquipamentoMedicao> {
        const response = await this.service.getEquipamentoMedicaoById({ idEquipamentoMedicao });
        return response.item;
    }

    async createEquipamentoMedicao(
        idObra: number,
        equipamento?: string,
        idFuncionario?: number,
        idFuncionarioMonit?: number,
        descResponsavelMonit?: string,
        responsavelCadastradoMonit?: string,
        frequenciaVerificao?: number,
        idFuncionarioResp?: number,
        descResponsavelResp?: string,
        responsavelCadastradoResp?: boolean,
        dataVerificacao?: Date,
        dataProxVerificacao?: Date,
        tipoMonitoramento?: string,
        arquivo?: string,
        nomeArquivo?: string,
        arquivo1?: string,
        nomeArquivo1?: string,
        observacao?: string,
        idCentroCusto?: number,
        idFornecedorMonit?: number,
        tipoVerificacao?: boolean,
        tipoRespEquipamento?: number,
        tipoCaliVeriiPor?: number,
        tipoFrequenciaData?: number

    ): Promise<number> {
        const result = await this.service.createEquipamentoMedicao({
            idObra,
            equipamento,
            idFuncionario,
            idFuncionarioMonit,
            descResponsavelMonit,
            responsavelCadastradoMonit,
            frequenciaVerificao,
            idFuncionarioResp,
            descResponsavelResp,
            responsavelCadastradoResp,
            dataVerificacao,
            dataProxVerificacao,
            tipoMonitoramento,
            arquivo,
            nomeArquivo,
            arquivo1,
            nomeArquivo1,
            observacao,
            idCentroCusto,
            idFornecedorMonit,
            tipoVerificacao,
            tipoRespEquipamento,
            tipoCaliVeriiPor,
            tipoFrequenciaData
        });

        return result.idEquipamentoMedicao;
    };

    async deleteEquipamentoMedicaoById(id: number): Promise<void> {
        return this.service.deleteEquipamentoMedicaoById(id);
    }

    async updateEquipamentoMedicao(
        idEquipamentoMedicao?: number,
        idObra?: number | null,
        equipamento?: string,
        idFuncionario?: number,
        idFuncionarioMonit?: number,
        descResponsavelMonit?: string,
        responsavelCadastradoMonit?: string,
        frequenciaVerificao?: number,
        idFuncionarioResp?: number,
        descResponsavelResp?: string,
        responsavelCadastradoResp?: boolean,
        dataVerificacao?: Date,
        dataProxVerificacao?: Date,
        tipoMonitoramento?: string,
        arquivo?: string,
        nomeArquivo?: string,
        arquivo1?: string,
        nomeArquivo1?: string,
        observacao?: string,
        idCentroCusto?: number,
        idFornecedorMonit?: number,
        tipoVerificacao?: boolean,
        tipoRespEquipamento?: number,
        tipoCaliVeriiPor?: number,
        tipoFrequenciaData?: number,

        limparArquivo?: boolean,
        limparArquivo1?: boolean

    ): Promise<void> {
        await this.service.updateEquipamentoMedicao({
            idEquipamentoMedicao,
            idObra,
            equipamento,
            idFuncionario,
            idFuncionarioMonit,
            descResponsavelMonit,
            responsavelCadastradoMonit,
            frequenciaVerificao,
            idFuncionarioResp,
            descResponsavelResp,
            responsavelCadastradoResp,
            dataVerificacao,
            dataProxVerificacao,
            tipoMonitoramento,
            arquivo,
            nomeArquivo,
            arquivo1,
            nomeArquivo1,
            observacao,
            idCentroCusto,
            idFornecedorMonit,
            tipoVerificacao,
            tipoRespEquipamento,
            tipoCaliVeriiPor,
            tipoFrequenciaData,

            limparArquivo,
            limparArquivo1
        });

    }
    //#region Principal
    async getAllIndicadores(): Promise<EquipamentoMedIndicadores> {
        const response = await this.service.getAllIndicadores();
        return response.indicadores;
    }
    //#endregion

    async downloadEquipamentoMedicaoArquivo(
        idEquipamentoMedicao: number,
        nroArquivo: number,
    ): Promise<Blob> {
        return await this.service.downloadEquipamentoMedicaoArquivo({
            idEquipamentoMedicao,
            nroArquivo,
        });
    }

    async getAllEquipamentoMedicaoHistorico(
        idEquipamentoMedicao: number,
    ): Promise<EquipamentoMedicaoHistorico[]> {
        const response = await this.service.getAllEquipamentoMedicaoHistorico({ idEquipamentoMedicao });
        return response.itens;
    }

    async getAllCadastroCores(
        cor: string | null,
        dataInicio: Date | null,
        dataTermino: Date | null,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<CadastroCores>> {
        return await this.service.getAllCadastroCores({
            cor,
            dataInicio,
            dataTermino,
            page,
            rowsPerPage,
        });
    }

    async createCadastroCores(
        dataInicio: Date,
        dataFinal: Date,
        idCor: number,
        cor: string,
        corValor: string,
    ): Promise<void> {
        await this.service.createCadastroCores({
            dataInicio,
            dataFinal,
            idCor,
            cor,
            corValor,
        });
    }

    async updateCadastroCores(
        idCadastroCor: number,
        dataInicio: Date,
        dataFinal: Date,
        idCor: number,
        cor: string,
        corValor: string,
    ): Promise<void> {
        await this.service.updateCadastroCores({
            idCadastroCor,
            dataInicio,
            dataFinal,
            idCor,
            cor,
            corValor,
        });
    }

    async deleteCadastroCores(
        idCadastroCor: number,
    ): Promise<void> {
        await this.service.deleteCadastroCores({
            idCadastroCor,
        });
    }
}

